/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import AreaGeografica from 'Models/cadastros/AreaGeografica'
import {
  ExportParamsBodyRequest,
  ExportParamsRequest,
  ParamsRequest,
} from 'Services/__shared/types/resquest'
import ApiService from 'Services/ApiService'
import { ServiceListResponse } from 'Types/ServiceResponse'
import IFormAreasGeograficasFilter from 'Views/Cadastros/AreasGeograficas/IFormAreasGeograficasFilter'

const areasGeograficas = {
  getList: async (
    filter?: IFormAreasGeograficasFilter,
    params?: ParamsRequest,
  ) => {
    const result: AxiosResponse<ServiceListResponse<AreaGeografica>> =
      await ApiService().get<ServiceListResponse<AreaGeografica>>(
        QueryStringFilter(
          `${hosts.WS_CADASTRO}/AreaGeografica`,
          filter,
          params,
        ),
      )

    return result
  },
  export: async (
    filter: IFormAreasGeograficasFilter,
    params?: ExportParamsRequest,
    exportFields?: ExportParamsBodyRequest,
  ) => {
    const result: AxiosResponse<string> = await ApiService().post<string>(
      QueryStringFilter(
        `${hosts.WS_CADASTRO}/AreaGeografica/Exportar`,
        filter,
        params,
      ),
      exportFields,
    )

    return result
  },
}

export default areasGeograficas
